import _sfc_main from "./AISubtitles.vue2.mjs";
/* empty css                  */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.subtitleLines.length ? _c("div", { staticClass: "ai-subtitles" }, _vm._l(_setup.subtitleLines, function(line) {
    return _c("div", { key: line.sender }, [_vm._v(" " + _vm._s(`${_setup.roomService.roomStore.getDisplayName(line.sender)}: ${line == null ? void 0 : line.text}`) + " ")]);
  }), 0) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "dd3035b9"
);
const AISubtitlesOverlay = __component__.exports;
export {
  AISubtitlesOverlay as default
};
